import React, {useContext} from "react";
import Avatar from "../../components/shared/Avatar";
import {AuthContext} from "../../context/authContext";
import ClientUserMenuItems from "./ClientUserMenuItems";

const ClientUserMenu = () => {
  const {user} = useContext(AuthContext)

  return (
    <div className="navbar-nav col-md-6 justify-content-md-center dropdown ">
      <a href='#'
         className="d-block link-body-emphasis text-decoration-none dropdown-toggle"
         data-bs-toggle="dropdown" aria-expanded="false">
        <Avatar src={user.avatar} alt={user.fullName} width={32} height={32}
                className="rounded-circle object-fit-cover"/>
        <span className='ps-2'>{user.fName}</span>
      </a>
      <ul className="dropdown-menu text-small">
        <ClientUserMenuItems/>
      </ul>
    </div>
  )
}
export default ClientUserMenu